import { useCallback } from 'react';

import { AmpliMessages, getDeviceSize, logAmplitudeEvent } from '../helpers';

import useWindowSize from './useWindowSize';

export const useTrackEvent = () => {
  const { width } = useWindowSize();

  const trackClick = useCallback(
    <K extends keyof AmpliMessages>(
      eventName: K,
      eventData?: Partial<AmpliMessages[K]>,
    ) => {
      if (typeof window === 'undefined' || !eventData || !width) {
        return;
      }

      // keeping this here, it's handy for testing
      // console.log('Log Event', eventName, eventData);
      logAmplitudeEvent(eventName, {
        ...(eventData || {}),
        'current page': window.location.href,
        'screen size': getDeviceSize(width),
      });
    },
    [width],
  );

  return trackClick;
};

export default useTrackEvent;
